import React from 'react';
import InputValidator from './InputValidator';

// Show a confirmation message for a few seconds before user can actually accept it,
// so that they can read the message and understand the weight
// of their decision before tapping a button just because it appeared.

// 2020-09-10 - Add a text field to capture user's signature.

export default class ConfirmationBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeoutHandle: 0,
            submitAble: false,
            signature: ''
        };
    }

    componentDidMount() {
        this.setState({
            submitAble: false,
            timeoutHandle: setTimeout(() => {
                this.setState({ submitAble: true });
            }, this.props.canSubmitAfter || 555)
        });
    }

    componentWillUnmount() {
        if (this.state.timeoutHandle) clearTimeout(this.state.timeoutHandle);
    }

    render() {
        const message = typeof this.props.message === 'string' ? [this.props.message] : this.props.message;
        return (
            <div style={{ padding: '1em' }} className={this.props.className}>
                {message.map((m) => (m ? <p>{m}</p> : null))}
                <hr />
                <button type="button" onClick={this.props.cancel}>
                    {this.props.cancelText}
                </button>
                <br />
                <br />
                <p>By inputting a signature below you agree that this signature is the legal equivalent of your manual signature.</p>
                <label htmlFor="signature">Signature</label>
                <input
                    id="signature"
                    autoComplete="off"
                    type="text"
                    name="signature"
                    value={this.state.signature}
                    onChange={(e) => {
                        this.setState({ signature: InputValidator.allowChars(e.target.value, /[a-z\-.' ]/i) });
                    }}
                />
                <br />
                <br />
                <button
                    disabled={!this.state.submitAble || !this.state.signature}
                    type="button"
                    onClick={() => {
                        // intent: prevent multiple button clicks
                        this.setState({ submitAble: false });
                        this.props.submit(this.state.signature);
                    }}
                >
                    {this.props.submitText}
                </button>
            </div>
        );
    }
}
